import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { Role } from '../domain/role';
import { UserKey } from './types';

export const useGetBusinessAreaUserProfiles = () => {
  return useQuery<Role[]>(
    [...UserKey.BUSINESS_AREA_USERS_PROFILES],
    () => usersRepo.getBusinessAreaUserProfiles(),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
